enum Basket {
  ItemCountLimitExceeded = "PBBTAItemCountLimitExceeded",
  OpenValueMinLimitNotReached = "PBBTAOpenValueMinLimitNotReached",
  OpenValueMaxLimitExceeded = "PBBTAOpenValueMaxLimitExceeded",
  RedemptionAmountLimitExceeded = "PBBTARedemptionAmountLimitExceeded",
  NotRedeemableInEventWindow = "PBBTANotRedeemableInEventWindow",
  InvalidEntityType = "PBBTAInvalidEntityType"
}

export default Basket
